import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueToasted from 'vue-toasted';
import { Datetime } from "vue-datetime";
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment';

// import 'css/free.min.css';

var dotenv = require('dotenv');
var dotenvExpand = require('dotenv-expand');

import { Settings } from 'luxon'

Settings.defaultLocale = 'id'
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueToasted);
Vue.use(moment)
Vue.component('datetime', Datetime);

Vue.prototype.$log = console.log.bind(console);
var myEnv = dotenv.config();
dotenvExpand(myEnv);
Vue.filter('thousandSeparator', function (amount) {
  if (!amount) {
    return 0;
  }
  if (
    amount !== "" ||
    amount !== undefined ||
    amount !== 0 ||
    amount !== "0" ||
    amount !== null
  ) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return amount;
  }
});

Vue.filter('dateFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('DD MMM YYYY')
  }
  return moment(date).format('DD MMM YYYY')
});

Vue.filter('monthFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('MMM YYYY')
  }
  return moment(date).format('MMM YYYY')
});

Vue.filter('dateTimeFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('DD MMM YYYY HH:mm:ss')
  }
  return moment(date).format('DD MMM YYYY HH:mm:ss')
});

Vue.filter('timeFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('HH:mm:ss')
  }
  return moment(date).format('HH:mm:ss')
});

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
